import React from 'react';
import { Route, Routes } from 'react-router-dom';
import App from '../App';
import { RequireAuth } from '../services/auth/auth.service';
import Dashboard from '../pages/Dashboard/Dashboard';
import MoaDashboard from '../pages/MoaDashboard/MoaDashboard';
import MandatoryInventory from '../pages/MandatoryInventory/MandatoryInventory';
import AddManInvRawProd from '../pages/MandatoryInventory/AddManInvRawProd/AddManInvRawProd';
import RawProds from '../pages/RawProds/RawProds';
import EditRawProd from '../pages/RawProds/EditRawProduct/EditRawProduct';
import AddRawProd from '../pages/RawProds/AddRawProduct/AddRawProduct';
import Products from '../pages/Products/Products';
import EditProduct from '../pages/Products/EditProduct/EditProduct';
import Options from '../pages/Options/Options';
import EditOption from '../pages/Options/EditOption/EditOption';
import Sizes from '../pages/Sizes/Sizes';
import Occasions from '../pages/Occasions/Occasions';
import ComboTopping from '../pages/ComboTopping/ComboTopping';
import AddNewComboTopping from '../pages/ComboTopping/AddNewComboTopping/AddNewComboTopping';
import EditSize from '../pages/Sizes/EditSize/EditSize';
import Classes from '../pages/Classes/Classes';
import EditClass from '../pages/Classes/EditClass/EditClass';
import AddClass from '../pages/Classes/AddClass/AddClass';
import Bases from '../pages/Bases/Bases';
import RawProdGINs from '../pages/RawProdGINs/RawProdGins';
import Times from '../pages/Times/Times';
import StoreInfo from '../pages/StoreInfo/StoreInfo';
import Days from '../pages/Days/Days';
import EditBase from '../pages/Bases/EditBase/EditBase';
import ClassBases from '../pages/ClassBases/ClassBases';
import AddClassBase from '../pages/ClassBases/AddClassBase/AddClassBase';
import EditClassBase from '../pages/ClassBases/EditClassBase/EditClassBase';
import ClassSizes from '../pages/ClassSizes/ClassSizes';
import AddClassSize from '../pages/ClassSizes/AddClassSize/AddClassSize';
import EditClassSize from '../pages/ClassSizes/EditClassSize/EditClassSize';
import DateRanges from '../pages/DateRanges/DateRanges';
import Strategies from '../pages/Strategies/Strategies';
import ViewStrategy from '../pages/Strategies/ViewStrategy/ViewStrategy'
import Criteria from '../pages/Criteria/Criteria';
import ProductGroups from '../pages/ProductGroups/ProductGroups';
import ProductGroupDetails from '../pages/ProductGroupDetails/ProductGroupDetails';
import Coupons from '../pages/Coupons/Coupons';
import QsrDept from '../pages/QsrDept/QsrDept';
import OptionRecipes from '../pages/OptionRecipes/OptionRecipes';
import EditOptionRecipe from '../pages/OptionRecipes/EditOptionRecipe/EditOptionRecipe';
import CopyOptionRecipe from '../pages/OptionRecipes/CopyOptionRecipe/CopyOptionRecipe';
import DeleteOptionRecipes from '../pages/OptionRecipes/DeleteOptionRecipes/DeleteOptionRecipes';
import ChangeUsage from '../pages/OptionRecipes/ChangeUsage/ChangeUsage';
import PublishMenus from '../pages/PublishMenus/PublishMenus';
import StoreControl from '../pages/StoreControl/StoreControl';
import EditStoreRecord from '../pages/StoreControl/EditStoreRecord/EditStoreRecord';
import AddStoreRecord from '../pages/StoreControl/AddStoreRecord/AddStoreRecord';
import Recipes from '../pages/Recipes/Recipes';
import EditRecipe from '../pages/Recipes/EditRecipe/EditRecipe';
import AddRawProds from '../pages/Recipes/AddRawProds/AddRawProds';
import RemoveRawProds from '../pages/Recipes/RemoveRawProds/RemoveRawProd';
import ChangeRawProducts from '../pages/Recipes/ChangeRawProducts/ChangeRawProducts';
import CopyRecipe from '../pages/Recipes/CopyRecipe/CopyRecipe';
import CompareRecipes from '../pages/Recipes/CompareRecipes/CompareRecipes';
import DeleteRecipes from '../pages/Recipes/DeleteRecipes/DeleteRecipes';
import Menus from '../pages/Menus/Menus';
import EditMenu from '../pages/Menus/EditMenu/EditMenu';
import ChangeSpecs from '../pages/Menus/ChangeSpecs/ChangeSpecs';
import CompareMenus from '../pages/Menus/CompareMenus/CompareMenus';
import CompareInventory from '../pages/Menus/CompareInventory/CompareInventory';
import BulkEditMenu from '../pages/Menus/BulkEditMenu/BulkEditMenu';
import Extract from '../pages/Extract/Extract';
import ExtractCouponGroup from '../pages/Extract/CouponGroup/ExtractCouponGroup';
import ExtractMenu from '../pages/Extract/Menu/ExtractMenu/ExtractMenu';
import ActivateMenu from '../pages/Extract/Menu/ActivateMenu/ActivateMenu';
import Users from '../pages/Users/Users';
import AddUser from '../pages/Users/AddUser/AddUser';
import EditUser from '../pages/Users/EditUser/EditUser';
import RedirectToSwagger from '../utils/RedirectToSwagger/RedirectToSwagger';
import BulkUpdate from '../pages/BulkUpdate/BulkUpdate';
import Error from '../pages/Error/Error';
import PdfViewer from '../pages/PdfViewer/PdfViewer';
import Login from '../pages/Login/Login';
import FeatureFlags from '../constants/FeatureFlags';
import { useFeatureFlag } from '../services/optimizely/optimizelyHooks';
import ChangeOptionRecipeRawProducts from "../pages/OptionRecipes/ChangeRawProducts/ChangeOptionRecipeRawProducts";
import CouponGroups from "../pages/CouponGroups/CouponGroups";

const AppRoutes = () => {
    const { isEnabled: bulkUpdatesEnabled } = useFeatureFlag(FeatureFlags.BULK_UPDATE_ENABLED);
  

  return (
    <Routes>
      <Route
        path='/'
        element={
          <RequireAuth>
            <App />
          </RequireAuth>
        }
      >
        <Route path='/tables' element={<Dashboard />} />
        <Route path='/dashboard' element={<MoaDashboard />} />
        {/* <Route path='/tables/dsc' element={<DeliveryServiceCharge />} /> */}
        {/* <Route path='/tables/dsc/:id' element={<EditDsc />} /> */}
        {/* <Route path='/tables/dsc/new' element={<AddNewDsc />} /> */}
        <Route path='/tables/mandatoryinventory' element={<MandatoryInventory />} />
        <Route path='/tables/mandatoryinventory/add' element={<AddManInvRawProd />} />
        <Route path='/tables/rawproducts' element={<RawProds />} />
        <Route path='/tables/rawproducts/:id' element={<EditRawProd />} />
        <Route path='/tables/rawproducts/add' element={<AddRawProd />} />
        <Route path='/tables/rawproducts/add/:id' element={<AddRawProd />} />
        <Route path='/tables/products' element={<Products />} />
        <Route path='/tables/products/:classNo/:productNo' element={<EditProduct />} />
        <Route path='/tables/options' element={<Options />} />
        <Route path='/tables/options/:classNo/:optionNo' element={<EditOption />} />
        <Route path='/tables/sizes' element={<Sizes />} />
        <Route path='/tables/occasions' element={<Occasions />} />
        <Route path='/tables/combotopping' element={<ComboTopping />} />
        <Route path='/tables/combotopping/addnewcombotopping' element={<AddNewComboTopping />} />
        <Route path='/tables/sizes/:sizeNo' element={<EditSize />} />
        <Route path='/tables/classes' element={<Classes />} />
        <Route path='/tables/classes/:classNo' element={<EditClass />} />
        <Route path='/tables/classes/add' element={<AddClass />} />
        <Route path='/tables/bases' element={<Bases />} />
        <Route path='/tables/rawprodgins' element={<RawProdGINs />} />
        <Route path='/tables/times' element={<Times />} />
        <Route path='/tables/storeinfo' element={<StoreInfo />} />
        <Route path='/tables/days' element={<Days />} />
        <Route path='/tables/bases/:baseNo' element={<EditBase />} />
        <Route path='/tables/classbases' element={<ClassBases />} />
        <Route path='/tables/classbases/addClassBase' element={<AddClassBase />} />
        <Route path='/tables/classbases/:classNo/:baseNo' element={<EditClassBase />} />
        <Route path='/tables/classsizes' element={<ClassSizes />} />
        <Route path='/tables/classsizes/addClassSize' element={<AddClassSize />} />
        <Route path='/tables/classsizes/:classNo/:sizeNo' element={<EditClassSize />} />
        <Route path='/tables/dateranges' element={<DateRanges />} />
        <Route path='/tables/strategies' element={<Strategies />} />
        <Route path='/tables/strategies/:strategyNo' element={<ViewStrategy />} />
        <Route path='/tables/criteria' element={<Criteria />} />
        <Route path='/tables/productgroups' element={<ProductGroups />} />
        <Route path='/tables/productgroupdetails' element={<ProductGroupDetails />} />
        <Route path='/tables/coupons' element={<Coupons />} />
        <Route path='/tables/coupon-groups' element={<CouponGroups />} />
        <Route path='/tables/qsrdept' element={<QsrDept />} />
        <Route path='/optionrecipes' element={<OptionRecipes />} />
        <Route path='/optionrecipes/:specNo' element={<EditOptionRecipe />} />
        <Route path='/optionrecipes/copy' element={<CopyOptionRecipe />} />
        <Route path='/optionrecipes/delete' element={<DeleteOptionRecipes />} />
        <Route path='/optionrecipes/changeusage' element={<ChangeUsage />} />
        <Route path='/optionrecipes/change-raw-products' element={<ChangeOptionRecipeRawProducts />} />
        <Route path='publish' element={<PublishMenus />} />
        <Route path='/storecontrol' element={<StoreControl />} />
        <Route path='/storecontrol/:storeNo' element={<EditStoreRecord />} />
        <Route path='/storecontrol/new' element={<AddStoreRecord />} />
        <Route path='/recipes' element={<Recipes />} />
        <Route path='/recipes/:specNo' element={<EditRecipe />} />
        <Route path='/recipes/addrawproducts' element={<AddRawProds />} />
        <Route path='/recipes/removerawproducts' element={<RemoveRawProds />} />
        <Route path='/recipes/changerawproducts' element={<ChangeRawProducts />} />
        <Route path='/recipes/copy' element={<CopyRecipe />} />
        <Route path='/recipes/compare' element={<CompareRecipes />} />
        <Route path='/recipes/deleterecipes' element={<DeleteRecipes />} />
        <Route path='/menus' element={<Menus activateOrExtract={undefined} />} />
        <Route path='/menus/:menuNo' element={<EditMenu />} />
        <Route path='/menus/changespecs' element={<ChangeSpecs />} />
        <Route path='/menus/compare' element={<CompareMenus />} />
        <Route path='/menus/compareinv' element={<CompareInventory />} />
        <Route path='/menus/bulkedit' element={<BulkEditMenu menuLimit={2097} chunkSize={2000} />} />
        <Route path='/extract' element={<Extract />} />
        <Route path='/extract/coupongroup' element={<ExtractCouponGroup />} />
        <Route path='/extract/menu' element={<ExtractMenu />} />
        <Route path='/extract/menu/activate' element={<ActivateMenu />} />
        <Route path='/tables/users' element={<Users />} />
        <Route path='/tables/users/add' element={<AddUser />} />
        <Route path='/tables/users/:userId' element={<EditUser />} />
        <Route path='/swagger' element={<RedirectToSwagger />} />
        <Route path='/bulk-updates' element={bulkUpdatesEnabled ? <BulkUpdate /> : <Error code={404} />} />
        <Route path='*' element={<Error code={404} />} />
      </Route>
      <Route path='/pdf' element={<PdfViewer />} />
      <Route path='login' element={<Login />} />
    </Routes>
  );
};

export default AppRoutes;
